import { render, staticRenderFns } from "./ItemShow.vue?vue&type=template&id=2cbddc09"
import script from "./ItemShow.vue?vue&type=script&lang=js"
export * from "./ItemShow.vue?vue&type=script&lang=js"
import style0 from "./ItemShow.vue?vue&type=style&index=0&id=2cbddc09&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports